/**
 * TANITIM SAYFASI — defter açılmadan önce (KURULUM_GEREKLI / KILITLI).
 *
 * Kullanıcı kararı (10.10.2026): ilk girişte tek sayfalık bir tanıtım sitesi;
 * menü yok. En üstteki "Gizlilik ve Profiller" kartının düğmesi bugünkü kurulum
 * ya da kilit ekranına götürür. Defter açılınca menü görünür ve ana sayfa
 * defterin durumuna göre şekil alır.
 *
 * Görseller (10.10.2026): başlık alanında örnek veriyle küçük bir rapor
 * görünümü, Gizlilik kartında verinin nereye gittiğini gösteren şema.
 */

import { Button } from "../../ui/primitives";
import { GizlilikSemasi, RaporOrnegi } from "./gorseller";
import { KARTLAR, Kart } from "./kartlar";
import { M } from "../../dil";
import { DilSecici } from "../DilSecici";

export type TanitimDurumu = "kurulum" | "kilitli";

export function TanitimSayfasi({ durum, onDefter }: { readonly durum: TanitimDurumu; readonly onDefter: () => void }) {
  return (
    <main className="min-h-dvh bg-bg">
      <header className="bg-gradient-to-br from-hero-from via-hero-via to-hero-to">
        <div className="mx-auto grid max-w-5xl gap-8 px-4 py-10 sm:py-14 lg:grid-cols-[minmax(0,1fr)_340px] lg:items-center lg:gap-10">
          <div>
            <div className="flex items-center justify-between gap-3">
              <p className="text-[13px] font-semibold uppercase tracking-wider text-hero-fg-soft">Parafon</p>
              <DilSecici kip="hero" />
            </div>
            <h1 className="mt-2 max-w-2xl text-[26px] font-semibold leading-tight tracking-tight text-hero-fg sm:text-[34px]">
              <span className="block">{M.anaSayfa.tanitim.satir1}</span>
              <span className="block">{M.anaSayfa.tanitim.satir2}</span>
              <span className="block">{M.anaSayfa.tanitim.satir3}</span>
            </h1>
            <p className="mt-3 max-w-2xl text-[15px] leading-relaxed text-hero-fg-soft">
              {M.anaSayfa.tanitim.giris}
            </p>
          </div>
          <div className="flex justify-center lg:justify-end">
            <RaporOrnegi />
          </div>
        </div>
      </header>
      <div className="mx-auto grid max-w-5xl gap-4 px-4 py-6 sm:grid-cols-2 lg:grid-cols-3">
        <Kart
          {...KARTLAR.defter}
          vurgulu
          gorsel={<GizlilikSemasi />}
          tanitim={
            <>
              {KARTLAR.defter.tanitim}
              <span className="mt-2 block font-semibold text-ink">
                {durum === "kurulum"
                  ? M.anaSayfa.tanitim.kurulumMetni
                  : M.anaSayfa.tanitim.kilitliMetni}
              </span>
            </>
          }
          eylem={
            <Button variant="primary" onClick={onDefter}>
              {durum === "kurulum" ? M.anaSayfa.tanitim.kurulumDugme : M.anaSayfa.tanitim.kilitliDugme}
            </Button>
          }
        />
        {[KARTLAR.baslangic, KARTLAR.fiyatlar, KARTLAR.raporlar, KARTLAR.yedek].map((k) => (
          <Kart key={k.kimlik} kimlik={k.kimlik} baslik={k.baslik} renk={k.renk} tanitim={k.tanitim} />
        ))}
      </div>
    </main>
  );
}
